let lastTrackedPath;

const sendPageView = location => {
  if (process.env.NODE_ENV !== 'production' || typeof window.gtag !== 'function') {
    return;
  }

  const pagePath = `${location.pathname}${location.search}${location.hash}`;

  if (pagePath === lastTrackedPath) {
    return;
  }

  lastTrackedPath = pagePath;

  window.gtag('event', 'page_view', {
    page_title: document.title,
    page_location: window.location.href,
    page_path: pagePath,
  });
};

exports.onClientEntry = () => {
  window.setTimeout(() => sendPageView(window.location), 0);
};

exports.onRouteUpdate = ({ location }) => {
  window.setTimeout(() => sendPageView(location), 0);
};
